// import Vue from 'vue'
// import VueI18n from 'vue-i18n'
// import locale from 'element-ui/lib/locale'
// import zh from './zh'
// import en from './en'

// Vue.use(VueI18n)

// let i18n = new VueI18n({
//   locale: localStorage.getItem('language') || 'zh',
//   messages: {
//     'zh': {
//       ...zh
//     },
//     'en': {
//       ...en
//     }
//   }
// })
// locale.i18n((key, value) => i18n.t(key, value))
// export default i18n;
import Vue from 'vue';
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);
// 引入各个语言配置文件
import zh from './zh';
import en from './en';
import es from './es'
import por from './por'
// 创建vue-i18n实例i18n
const i18n = new VueI18n({
  // 设置默认语言
  locale: localStorage.getItem('language') || 'zh',// 语言标识
  // 添加多语言（每一个语言标示对应一个语言文件）
  messages: {
    zh,
    en,
    es,
    por
  }
})
// 暴露i18n
export default i18n